import React from 'react';
import { Img, Div } from 'Components/GenericView';
import { NursingProcedures } from "Components/NursingProcedures";

export type NursingProceduresSectionPropType = {
  hasError: string | undefined;
  goneIfReadOnly: string;
  availableProcedures: any;
  selectedProcedures: any;
  dontAnimate: boolean | undefined;
  isReadOnly: boolean | undefined;
  onProceduresChange: (procs: any[]) => void;
}

const NursingProceduresSection = (props: NursingProceduresSectionPropType) => {
  const {
    hasError,
    goneIfReadOnly,
    availableProcedures,
    selectedProcedures,
    dontAnimate,
    isReadOnly,
    onProceduresChange
  } = props;

  return <>
    <div
      className={`nvd-row h${!selectedProcedures[0] ? goneIfReadOnly : ""
        }`}
      has-error={hasError}
    >
      <Img src="/nursing_procedures.png" className="nvd-icon" />

      {/* Nursing procedures */}
      <div className="h grow">
        <Div className="nvd-text no-shrink" width={86 + 23 + 18}>
          <span>Nursing Procedures</span>
        </Div>

        <span className="nvd-error nvd-srv-err nvd-err-long">
          <img
            alt="error"
            src="/warning_red.png"
            className="nvd-error-icon"
          />
          Please select some services
        </span>

        <NursingProcedures
          className="nvd-cont nvd-w100"
          tdClassName="nvd-service"
          tdInputClassName="nvd-proc-input"
          available_procedures={availableProcedures}
          selectedProcedures={selectedProcedures}
          dontAnimate={dontAnimate}
          readOnly={isReadOnly}
          onProceduresChange={onProceduresChange}
        />
      </div>
    </div>
  </>;
}

export default NursingProceduresSection;